import { createContext } from 'react';
import { WizardConfig } from './types';

/**
 * Acting as the dependency injection layer, WizardProvider provides the Wizard context to its children, allowing them to access the config and read-only data.
 *
 * @summary
 * WizardProvider is a React context provider component that supplies the wizard configuration
 * and read-only data to its descendant components via the WizardContext. This enables dynamic logic within a wizard flow.
 *
 * @param children - The child React nodes that will have access to the Wizard context.
 * @param config - The configuration object containing components, resolver functions for navigation, and validation.
 * @param onAfterSubmit - An optional callback function to be called after the wizard is submitted.
 * @param onCancel - An optional callback function to be called when the wizard is canceled.
 *
 */
export interface WizardContextType {
    config: WizardConfig;
    onAfterSubmit?: () => void;
    onCancel?: () => void;
}

export const WizardContext = createContext<WizardContextType | null>(null);
